// extracted by css-extract-rspack-plugin
export default {"Container":"yJhNj","Colors":"O9Tz2","Image":"AfkmS"};